import PaginatedDataTable from "./PaginatedDataTable";
export default PaginatedDataTable;
